const BASE_URL_PROD = "https://testride-backoffice.piaggio.com/api/testride";
const BASE_TESTRIDE_ACTION= "/action/testride";

import store from "@/store";

/**
 * Recupera i marker da /api/testride/${country}/${lang}/{brand}/
 */

export async function fetchMarkers(dateStr,brand, model, country, lang, params = {}) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    if (model === '') model = 'all';
    
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/${encodeURIComponent(model)}/stores/${query ? `?${query}` : ""}&startdate=${dateStr}`;
    // const url = 'https://lmp-qa.piaggiogroup.com/api/testride/it/it/aprilia/all/stores?clear=false&south=44.98110126276018&west=8.168031354640117&north=46.052058641625415&east=9.350434919093242&startdate=20251001'
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[fetchMarkers] Error:", error);
        return [];
    }

}


/**
 * Recupera i displacements da /action/testride/${country}/${lang}/{brand}/{model}/displacements
 */
export async function fetchDisplacementByModel(country, lang, brand, model) {
  // const query = new URLSearchParams(params).toString();
  if (model === '') model = 'all';
    
  const url = `${BASE_TESTRIDE_ACTION}/${country}/${lang}/${brand}/${model}/displacements`;
  console.log(`displacements url = ${url}`);
  try {
    const response = await fetch(url);
    if(!response.ok){
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json();
    return data.displacements;
  } catch (error) {
    console.error("[fetchStoreAvailableModels] Error:", error);
  }
}

/**
 * Recupera i driverlicenses da /action/testride/${country}/${lang}/{brand}/{model}/driverlicenses
 */
export async function fetchDriverLicensesByModel(country, lang, brand, model) {
  // const query = new URLSearchParams(params).toString();
  if (model === '') model = 'all';
    
  const url = `${BASE_TESTRIDE_ACTION}/${country}/${lang}/${brand}/${model}/driverlicenses`;

  try {
    const response = await fetch(url);
    if(!response.ok){
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json();
    return data.driverlicenses;
  } catch (error) {
    console.error("[fetchDriverLicensesByModel] Error:", error);
  }
}

/**
 * Recupera i models in base al dealer
 */
export async function fetchStoreAvailableModels(country, lang, brand, dealercd, params = {}) {
    //const BASE_URL_2 = store.getters['testrideStore/lmpApiUrl'];
    // console.log(`BASE_URL_2 ${BASE_URL_2}`);
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/stores/${dealercd}/vehicles/${query ? `?${query}` : ""}`;
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[fetchStoreAvailableModels] Error:", error);
        return [];
    }

}



/**
 * Recupera engine in base al dealer e modello
 */
// https://testride-backoffice.piaggio.com/api/testride/it/it/Aprilia/stores/ITA292S2/vehicles/tuono%20457/displacements?clear=false
export async function fetchStoreAvailableEngines(country, lang, brand, dealercd, model, params = {}) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const query = new URLSearchParams(params).toString();
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/stores/${dealercd}/vehicles/${model}/displacements${query ? `?${query}` : ""}`;
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[fetchStoreAvailableEngines] Error:", error);
        return [];
    }

}


/**
 * Recupera appointment in base al dealer e date
 */

// https://testride-backoffice.piaggio.com/api/testride/it/it/Aprilia/stores/ITA464S1/vehicles/tuono%20457/457/appointments?clear=false&date=20251029
// {
//     "appointments": []
// }
export async function fetchAppointmentsByDate(country, lang, brand, dealercd, model, displacement, date) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    // const query = new URLSearchParams(date).toString();
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/stores/${dealercd}/vehicles/${model}/${displacement}/appointments?date=${date}`;
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[fetchAppointmentsByDate] Error:", error);
        return [];
    }

}


/**
 * Recupera ExtraAvailabilitiesByDate in base al dealer
 */

// https://testride-backoffice.piaggio.com/api/testride/it/it/Aprilia/stores/ITA464S1/vehicles/tuono%20457/457/extraavailabilities?clear=false&date=20251029
// {
//     "vehicleStoreExtraAvailabilities": [],
//     "storeExtraAvailabilities": []
// }

export async function fetchExtraAvailabilitiesByDate(country, lang, brand, dealercd, model, displacement, date) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    // const query = new URLSearchParams(date).toString();
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/stores/${dealercd}/vehicles/${model}/${displacement}/extraavailabilities?date=${date}`;
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[fetchExtraAvailabilitiesByDate] Error:", error);
        return [];
    }

}


/**
 * Recupera info dealer
 */

// https://testride-backoffice.piaggio.com/api/testride/it/it/aprilia/tuono%20457/stores/ita292s2?clear=false

export async function loadDealer(country, lang, brand, dealercd, model ) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/${model}/stores/${dealercd}`;
    
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);
        return await response.json();
        } catch (error) {
            console.error("[loadDealer] Error:", error);
        return [];
    }

}

export async function saveAppointment(country, lang, brand, dealercd, modelName, displacement, date, userName, userSurname, userEmail, policy1, policy2, profilingOptIn, telephone, catoken, vehicleId = null) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/${encodeURIComponent(brand)}/stores/${dealercd}/appointments?catoken=`.toLowerCase() + catoken;

    const payload = {
        brand,
        dealercd,
        modelName,
        displacement,
        date,
        userName,
        userSurname,
        userEmail,
        policy1,
        policy2,
        profilingOptIn,
        telephone
    };
    if (vehicleId != null) {
        payload.vehicleId = vehicleId;
    }
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: store?.authToken ? `Bearer ${store.authToken}` : undefined,
            },
            body: JSON.stringify(payload),
        });
        return response;
    } catch (error) {
        console.error("[saveAppointment] Error:", error);
        return [];
    }
}


export async function recoveryAppointment(country, lang, email) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/appointments/recovery?email=${email}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: store?.authToken ? `Bearer ${store.authToken}` : undefined,
            },
        });
        return response;
    } catch (error) {
        console.error("[recoverAppointment] Error:", error);
        return [];
    }
}

export async function loadAppointment(country, lang, token) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/appointment/${token}`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);

    return response.json();
}


export async function completeInformationAppointment(country, lang, token, userEmail, driverLicenseType, driverLicenseNumber, address, city, streetNumber, zip, catoken) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/appointments/${token}?catoken=`.toLowerCase() + catoken;

    const payload = {
        userEmail,
        driverLicenseType,
        driverLicenseNumber,
        address,
        city,
        streetNumber,
        zip,
    };
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: store?.authToken ? `Bearer ${store.authToken}` : undefined,
            },
            body: JSON.stringify(payload),
        });
        return response;
    } catch (error) {
        console.error("[completeInformationAppointment] Error:", error);
        return [];
    }
}

export async function editAppointment(country, lang, token, userEmail, date, catoken) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/appointments/${token}?catoken=`.toLowerCase() + catoken;

    const payload = {
        userEmail,
        date
    };
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: store?.authToken ? `Bearer ${store.authToken}` : undefined,
            },
            body: JSON.stringify(payload),
        });
        return response;
    } catch (error) {
        console.error("[editAppointment] Error:", error);
        return [];
    }
}


export async function cancelAppointment(country, lang, token, userEmail, reason, catoken) {
    const BASE_URL = store.getters['testrideStore/lmpApiUrl'];
    const url = `${BASE_URL}/${country}/${lang}/appointments/${token}/cancel?catoken=`.toLowerCase() + catoken;

    const payload = {
        userEmail,
        reason
    };
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                // Authorization: store?.authToken ? `Bearer ${store.authToken}` : undefined,
            },
            body: JSON.stringify(payload),
        });
        return response;
    } catch (error) {
        console.error("[editAppointment] Error:", error);
        return [];
    }
}